import { Link } from "react-router-dom";
import { MessageCircle, Phone, MapPin } from "lucide-react";
import { useLang } from "../i18n";
import { SERVICES, ZONES, WA_LINK, PHONE_DISPLAY } from "../data/site";

export default function Footer() {
  const { lang, t } = useLang();
  const prefix = lang === "ca" ? "/ca" : "";

  return (
    <footer data-testid="site-footer" className="border-t border-white/5 bg-[#080808]">
      <div className="mx-auto grid max-w-7xl gap-12 px-4 py-16 sm:px-6 md:grid-cols-2 lg:grid-cols-4 lg:px-12">
        <div>
          <img src="/logo.jpg" alt="EcoGlow Detailing" className="h-12 w-auto rounded-sm object-contain" />
          <p className="mt-4 text-sm leading-relaxed text-zinc-400">{t("footer.desc")}</p>
          <p className="mt-4 font-mono2 text-[10px] uppercase tracking-[0.3em] text-zinc-600">{t("footer.madeIn")}</p>
        </div>

        <div>
          <h3 className="font-mono2 text-xs uppercase tracking-[0.25em] text-[#8BFF32]">{t("footer.services")}</h3>
          <ul className="mt-4 space-y-2">
            {SERVICES.slice(0, 7).map((s) => (
              <li key={s.slug}>
                <Link
                  to={`${prefix}/servicios/${s.slug}`}
                  data-testid={`footer-service-${s.slug}-link`}
                  className="text-sm text-zinc-400 transition-colors hover:text-[#8BFF32]"
                >
                  {s[lang]?.name || s.es.name}
                </Link>
              </li>
            ))}
          </ul>
        </div>

        <div>
          <h3 className="font-mono2 text-xs uppercase tracking-[0.25em] text-[#8BFF32]">{t("footer.company")}</h3>
          <ul className="mt-4 space-y-2">
            <li><Link data-testid="footer-packs-link" to={`${prefix}/packs`} className="text-sm text-zinc-400 hover:text-[#8BFF32]">{t("nav.packs")}</Link></li>
            <li><Link data-testid="footer-works-link" to={`${prefix}/trabajos-realizados`} className="text-sm text-zinc-400 hover:text-[#8BFF32]">{t("nav.works")}</Link></li>
            <li><Link data-testid="footer-center-link" to={`${prefix}/nuestro-centro`} className="text-sm text-zinc-400 hover:text-[#8BFF32]">{t("nav.center")}</Link></li>
            <li><Link data-testid="footer-zones-link" to={`${prefix}/zonas-de-servicio`} className="text-sm text-zinc-400 hover:text-[#8BFF32]">{t("nav.zones")}</Link></li>
            <li><Link data-testid="footer-about-link" to={`${prefix}/sobre-ecoglow`} className="text-sm text-zinc-400 hover:text-[#8BFF32]">{t("nav.about")}</Link></li>
            <li><Link data-testid="footer-blog-link" to={`${prefix}/blog`} className="text-sm text-zinc-400 hover:text-[#8BFF32]">{t("nav.blog")}</Link></li>
          </ul>
        </div>

        <div>
          <h3 className="font-mono2 text-xs uppercase tracking-[0.25em] text-[#8BFF32]">{t("footer.contact")}</h3>
          <div className="mt-4 space-y-3">
            <a href={WA_LINK} target="_blank" rel="noopener noreferrer" data-testid="footer-whatsapp-link" className="flex items-center gap-2 text-sm text-zinc-300 hover:text-[#8BFF32]">
              <MessageCircle className="h-4 w-4 text-[#63E51D]" /> {PHONE_DISPLAY}
            </a>
            <a href={`tel:${PHONE_DISPLAY.replace(/\s/g, "")}`} data-testid="footer-phone-link" className="flex items-center gap-2 text-sm text-zinc-300 hover:text-[#8BFF32]">
              <Phone className="h-4 w-4 text-[#63E51D]" /> {PHONE_DISPLAY}
            </a>
            <p className="flex items-start gap-2 text-sm text-zinc-400">
              <MapPin className="mt-0.5 h-4 w-4 shrink-0 text-[#63E51D]" /> Els Muntells, Tarragona
            </p>
          </div>
          <h3 className="mt-8 font-mono2 text-xs uppercase tracking-[0.25em] text-[#8BFF32]">{t("footer.zonesTitle")}</h3>
          <p className="mt-3 text-sm leading-relaxed text-zinc-500">{ZONES.join(" · ")}</p>
        </div>
      </div>
      <div className="border-t border-white/5 py-6 text-center">
        <p className="text-xs text-zinc-600">
          © {new Date().getFullYear()} EcoGlow Detailing · {t("footer.rights")}
        </p>
      </div>
    </footer>
  );
}
